import { defineMessage } from 'react-intl';

/** Localized copy for media-limits publish indications. */
export const mediaLimitsMessages = {
  blocked: defineMessage({
    id: 'socialExport.mediaLimits.blocked',
    defaultMessage: 'El video supera la duración máxima permitida por la plataforma.',
  }),
  blockedWithMax: defineMessage({
    id: 'socialExport.mediaLimits.blockedWithMax',
    defaultMessage:
      'El video supera la duración máxima permitida por la plataforma ({maxMinutes} min).',
  }),
  needsTranscoding: defineMessage({
    id: 'socialExport.mediaLimits.needsTranscoding',
    defaultMessage:
      'El tamaño del video supera el límite de la plataforma; se reducirá a {quality}p para poder publicarlo.',
  }),
  platformDisplaysLower: defineMessage({
    id: 'socialExport.mediaLimits.platformDisplaysLower',
    defaultMessage: '{platformName} lo mostrará en hasta {quality}p.',
  }),
};
